const PARAMETER_LIMIT = 200;

interface AuthCallback {
    (error: unknown, response: unknown): void;
}

type Request = Record<string, AuthCallback>;

interface ReduceState {
    lastBatchKeysLength: number;
    batches: Request[];
}

export default function splitRequestsIntoBatches(requests: Request): Request[] {
    const { batches } = Object.keys(requests).reduce((acc, channelName) => {
        if (acc.lastBatchKeysLength === PARAMETER_LIMIT) {
            acc.batches.push({
                [channelName]: requests[channelName]
            });
            acc.lastBatchKeysLength = 1;
            return acc;
        }
        acc.lastBatchKeysLength++;
        acc.batches[acc.batches.length - 1][channelName] = requests[channelName];
        return acc;
    }, {
        // purpose of this is to avoid repeated calls to Object.keys
        // since requests key size can be big
        lastBatchKeysLength: 0,
        batches: [{}]
    } as ReduceState);
    return batches;
}
